import { Link } from 'react-router-dom';
import { Star, Lock } from 'lucide-react';
import type { List } from '../../types/list';

interface FavoritesPinnedCardProps {
  list: List;
}

/**
 * The system Favorites list, pinned to the top of the Lists index (Mine scope).
 * Gold-accented per favorites-mobile.html Frame A — amber-500 is #f59e0b, the
 * canonical star color used app-wide (FavoriteStar).
 */
export function FavoritesPinnedCard({ list }: FavoritesPinnedCardProps) {
  const count = list.count ?? 0;

  return (
    <Link to={`/lists/${list.id}`} className="block">
      <div className="bg-amber-50 dark:bg-amber-950/20 border border-amber-200 dark:border-amber-900/40 border-l-4 border-l-[#f59e0b] rounded-lg p-3 sm:p-4 shadow-sm hover:shadow-md transition-shadow">
        {/* Header: gold star + Favorites + lock pushed right */}
        <div className="flex items-center gap-2">
          <Star className="h-4 w-4 text-amber-500 fill-current flex-shrink-0" />
          <span className="font-bold text-gray-900 dark:text-gray-100">Favorites</span>
          <Lock className="h-3.5 w-3.5 text-amber-700/70 dark:text-amber-500/70 ml-auto flex-shrink-0" />
        </div>

        {/* Count line */}
        <div className="text-sm text-gray-500 dark:text-gray-400 mt-1.5">
          {count} {count === 1 ? 'item' : 'items'}
        </div>

        {/* Footer line */}
        <div className="text-xs text-amber-700 dark:text-amber-500 mt-1.5">
          Only you · always here
        </div>
      </div>
    </Link>
  );
}
